import { render } from "./LayerPeta.vue?vue&type=template&id=c88daa24"
import script from "./LayerPeta.vue?vue&type=script&lang=js"
export * from "./LayerPeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__